import { MerchantWithholdStatuses } from "types";

const loadOptions = () => ({
	options: MerchantWithholdStatuses,
	hasMore: false,
});

const merchantWithholdReasonColumn = () => ({
	name: "merchantWithholdReason",
	type: "select" as const,
	loadOptions,
	getOptionLabel: option => option.displayName,
	getOptionValue: option => option.value,
	placeholder: "Merchant Withhold Reason",
});

export default merchantWithholdReasonColumn;
